import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";
import { USER_MGMT_CNST } from "../../constants/proj.cnst";

@Injectable({
  providedIn: "root"
})
export class ApiResponseInterceptor implements HttpInterceptor {
  
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      tap((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
          if (!req.url?.includes('json') && !req.url?.includes(USER_MGMT_CNST.API_MAPPING.GET_CSRF_TOKEN)) {
            const csrfToken = event.headers?.get('csrfToken');
            if (csrfToken) {
              localStorage.setItem('csrfToken', csrfToken);
            }
          }
        }
        return event;
      })
    );
  }
}
